import PrintResi from './resi';

const routes = [
  {
    path: '/print/resi/:id.jpeg',
    component: PrintResi,
  },
];

export default routes;
